import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import DocBody from "../components/DocBody";
import { TOOL_DOCS_BY_ID } from "../docs/toolDocs";
import { ArrowLeft } from "lucide-react";

export default function DocPage() {
  const { toolId } = useParams();
  const navigate = useNavigate();
  const doc = TOOL_DOCS_BY_ID[toolId];

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 py-8">
        <button
          data-testid="doc-back"
          onClick={() => navigate("/docs")}
          className="flex items-center gap-1.5 text-sm text-sage-500 hover:text-sage-700 mb-4"
        >
          <ArrowLeft className="w-4 h-4" /> All docs
        </button>
        <div data-testid={`doc-${toolId}`} className="bg-white border border-[#E2E8E3] rounded-md p-6 md:p-8">
          <DocBody doc={doc} toolId={toolId} />
        </div>
      </main>
    </div>
  );
}
